module.exports = __webpack_public_path__ + "static/img/time-weekly@2x.23ab82b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/commons/footer/time-weekly@2x.png
// module id = v571
// module chunks = 1